import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[accountValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: AccountValidatorDirective, multi: true }]
})
export class AccountValidatorDirective implements Validator {

  validate(control: AbstractControl): ValidationErrors | null {
    const accountPattern = /^[0-9]+[a-zA-Z0-9]$/;
    const valid = accountPattern.test(control.value);
    return valid ? null : { invalidAccount: true };
  }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/util/account-validator.directive.ts